<div class="row">
  <form class="col-md-12 d-flex justify-content-center" [formGroup]="formSearch" (submit)="onSearchField()">
    <i-input
      [iInput]="{
        placeholder: 'contactsDetails.search' | translate,
        options: {
          showRightButton: true,
          rightButtonText: 'Rechercher',
        },
      }"
      [type]="'text'"
      [control]="formSearch.get('search')"
      [showError]="false"
      styleClass="d-block w-100"
      (rightButtonClicked)="setActive(false); onSearchField()"></i-input>
    <!-- <i-button
      id="searchContactByNameOrFirstname"
      [pTooltip]="'contactsDetails.searchByNameOrFirstName' | translate"
      styleClass="blue ms-3"270106
      size="small"
      text="Rechercher"
      (click)="setActive(false); onSearchField()">
    </i-button> -->
  </form>
</div>

<div class="contacts__bigcontainer d-flex">
  <div class="container">
    <div class="contacts overflow">
      @if (searchString) {
        <span class="contacts__bigletter">{{ searchString }}</span>
      }

      @for (item of contacts; track item; let i = $index) {
        <div class="contacts__list" (click)="fct(click, item); toggleLine(i)" [ngClass]="{ active: i === activeContact }">
          <span class="contacts__name" pTooltip="{{ item?.nom ? item?.nom : '' }} {{ item?.prenom ? item?.prenom : '' }}">
            @if (item?.typeSociete) {
              <i class="bi bi-building me-1"></i>
            }
            @if (!item?.typeSociete) {
              <i class="bi bi-person-fill me-1"></i>
            }
            <b>{{ item?.nom ? (item.nom | maxLength: 30) : '' }}</b>
            {{ item?.prenom ? (item?.prenom | maxLength: 30) : '' }}
            @if (item?.contactParent) {
              <div class="d-inline-block">({{ item.contactParent.nom | maxLength: 30 }}{{ item.contactParent.prenom | maxLength: 30 }})</div>
            }
          </span>
          <span class="contacts__fonction" pTooltip="{{ item?.fonction }}">{{ item?.fonction | maxLength: 30 }}</span>
        </div>
      }
    </div>
  </div>
  <ul class="contacts__alphabets">
    <li [ngClass]="{ active: activeLine === -1 }">
      <span class="contacts__reset" (click)="reset(); setActive(false); activeLine = -1" [pTooltip]="'reset' | translate"
        ><i class="bi bi-x-circle resetIcon"></i
      ></span>
    </li>
    @for (letter of alphabets; track letter; let i = $index) {
      <li [ngClass]="{ active: i === activeLine }">
        <span (click)="onSearchLetter({ letter: letter }); searchString = letter; letterModel = letter; setActive(true); activeLine = i">{{
          letter
        }}</span>
      </li>
    }
  </ul>
</div>
